import { createRoute } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@/components/ui/page-container";

/**
 * `/admin/email/new` — editor de creación de plantilla addressable por URL
 * (campaña #15b). Antes era un signal local (`creating`) sin URL propia.
 * Segmento estático: gana a `$templateId` en el router.
 */
function AdminEmailNewPage() {
  const navigate = useNavigate();
  const back = () => {
    void navigate({ to: "/admin/email" });
  };
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        mode={() => "new"}
        onClose={back}
        onNew={back}
        onEdit={(id) => {
          void navigate({ to: "/admin/email/$templateId", params: { templateId: id } });
        }}
      />
    </PageContainer>
  );
}

export const adminEmailNewRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/new",
  component: AdminEmailNewPage,
});
